// extracted by mini-css-extract-plugin
export default {"tableContainer":"_2s-_G","select":"_1dkZz","portal":"_2iDM8"};